import React from 'react';
import { Admin, Resource } from 'react-admin';
import initDataProvider from './utils/dataProvider';
import initAuthProvider from './utils/authProvider';
import { ResourceWithPermissions } from 'ra-auth-acl';
import { BookingIcon, BookingList, BookingShow } from './containers/Booking';
import { CarBrandIcon, CarBrandList, CarBrandCreate, CarBrandEdit, CarBrandShow } from './containers/CarBrand';
import { CarModelIcon, CarModelList, CarModelCreate, CarModelEdit, CarModelShow } from './containers/CarModel';
import {
  ContactInfoIcon,
  ContactInfoList,
  ContactInfoCreate,
  ContactInfoEdit,
  ContactInfoShow,
} from './containers/ContactInfo';
import {
  SalesAdvisorIcon,
  SalesAdvisorList,
  SalesAdvisorCreate,
  SalesAdvisorEdit,
  SalesAdvisorShow,
} from './containers/SalesAdvisor';
import {
  ServiceConsultantIcon,
  ServiceConsultantList,
  ServiceConsultantCreate,
  ServiceConsultantEdit,
  ServiceConsultantShow,
} from './containers/ServiceConsultant';
import { CustomerIcon, CustomerList, CustomerCreate, CustomerEdit, CustomerShow } from './containers/Customer';
import {
  CustomerCarIcon,
  CustomerCarList,
  CustomerCarCreate,
  CustomerCarEdit,
  CustomerCarShow,
} from './containers/CustomerCar';
import { PromotionIcon, PromotionList, PromotionCreate, PromotionEdit } from './containers/Promotion';
import { VoucherIcon, VoucherList, VoucherCreate, VoucherEdit } from './containers/Voucher';
import { UserIcon, UserList, UserCreate, UserEdit, UserShow } from './containers/User';
import { RoleIcon, RoleList, RoleCreate, RoleEdit } from './containers/Role';
import customRoutes from './customRoutes';

import MyMenu from './MyMenu';

const dataProvider = initDataProvider();
const authProvider = initAuthProvider();
const App = () => (
  <Admin customRoutes={customRoutes} authProvider={authProvider} dataProvider={dataProvider} menu={MyMenu}>
    {permissions => [
      <ResourceWithPermissions
        permissions={permissions}
        icon={CarBrandIcon}
        name="brands"
        options={{ label: 'Car Brands' }}
        list={CarBrandList}
        show={CarBrandShow}
        create={CarBrandCreate}
        edit={CarBrandEdit}
      />,
      <ResourceWithPermissions
        permissions={permissions}
        icon={CarModelIcon}
        name="models"
        options={{ label: 'Car Models' }}
        list={CarModelList}
        show={CarModelShow}
        create={CarModelCreate}
        edit={CarModelEdit}
      />,
      <ResourceWithPermissions
        permissions={permissions}
        icon={BookingIcon}
        name="bookings"
        options={{ label: 'Bookings' }}
        list={BookingList}
        show={BookingShow}
      />,
      <ResourceWithPermissions
        permissions={permissions}
        icon={SalesAdvisorIcon}
        name="sales_advisors"
        options={{ label: 'Sales Consultants' }}
        list={SalesAdvisorList}
        show={SalesAdvisorShow}
        create={SalesAdvisorCreate}
        edit={SalesAdvisorEdit}
      />,
      <ResourceWithPermissions
        permissions={permissions}
        icon={ServiceConsultantIcon}
        name="service_consultants"
        options={{ label: 'Service Consultants' }}
        list={ServiceConsultantList}
        show={ServiceConsultantShow}
        create={ServiceConsultantCreate}
        edit={ServiceConsultantEdit}
      />,
      <ResourceWithPermissions
        permissions={permissions}
        icon={CustomerIcon}
        name="customers"
        options={{ label: 'Customers' }}
        list={CustomerList}
        show={CustomerShow}
        create={CustomerCreate}
        edit={CustomerEdit}
      />,
      <ResourceWithPermissions
        permissions={permissions}
        icon={CustomerCarIcon}
        name="cars"
        options={{ label: 'Customer Cars' }}
        list={CustomerCarList}
        show={CustomerCarShow}
        create={CustomerCarCreate}
        edit={CustomerCarEdit}
      />,
      <ResourceWithPermissions
        permissions={permissions}
        icon={PromotionIcon}
        name="promotions"
        options={{ label: 'Promotions' }}
        list={PromotionList}
        create={PromotionCreate}
        edit={PromotionEdit}
      />,
      <ResourceWithPermissions
        permissions={permissions}
        icon={VoucherIcon}
        name="vouchers"
        options={{ label: 'Voucher' }}
        list={VoucherList}
        create={VoucherCreate}
        edit={VoucherEdit}
      />,
      <ResourceWithPermissions
        permissions={permissions}
        icon={ContactInfoIcon}
        name="contactinfos"
        options={{ label: 'Contact Infos' }}
        list={ContactInfoList}
        show={ContactInfoShow}
        create={ContactInfoCreate}
        edit={ContactInfoEdit}
      />,
      <ResourceWithPermissions
        permissions={permissions}
        icon={UserIcon}
        name="users"
        options={{ label: 'User Access Rights' }}
        list={UserList}
        show={UserShow}
        create={UserCreate}
        edit={UserEdit}
      />,
      <ResourceWithPermissions
        permissions={permissions}
        icon={RoleIcon}
        name="roles"
        options={{ label: 'User Access Roles' }}
        list={RoleList}
        create={RoleCreate}
        edit={RoleEdit}
      />,
      <Resource name="user-vouchers" />,
      <Resource name="countries" />,
    ]}
  </Admin>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js